export const phoneMask = '+7 (###) ###-##-##';
export const innRuMask = '#'.repeat(10);
export const innOtherMask = '#'.repeat(20);
export const innRuIPMask = '#'.repeat(12);
export const kppRuMask = '#'.repeat(9);
export const kppOtherMask = '#'.repeat(20);
export const ogrnMask = '#'.repeat(13);
export const ogrnipMask = '#'.repeat(15);
export const placesMask = '#';
export const agesMask = '###';
export const quotaMask = '########';
export const stopSalePeriodMask = '###';
export const orderPeriodMask = '###';
export const yearMask = '####';

export const commonNumberMask = '#'.repeat(9);
export const commonNumberMaskForValidation = '#'.repeat(10);

export const timeMask = '##:##';

export const phoneMasks = {
  RU: '+7 (###) ###-##-##',
  AZ: '+994-##-###-##-##',
  AM: '+374-##-###-###',
  BY: '+375 (##) ###-##-##',
  GE: '+995(###)###-###',
  KZ: '+7 (7##) ###-##-##',
  KG: '+996 (###) ###-###',
  TJ: '+992-##-###-####',
  UZ: '+998-##-###-####',
};

// below - deprecated
export const touristsCountMask = '###';
export const dateMask = '##.##.####';
export const decimalFractionalNumberMask = (value: string) => {
  const regEx = /[\d,.]/;
  const decimalRegEx = /[,.]/;
  const numberRegEx = /\d/;

  if (value.length === 1) {
    return [numberRegEx];
  }

  const match = decimalRegEx.exec(value);

  if (match) {
    value = value.slice(0, match.index);

    const mask = Array.from({ length: Math.min(value.length, 5) }, () => regEx);

    return [...mask, decimalRegEx, numberRegEx, numberRegEx];
  }

  return Array.from({ length: 5 }, (_, index) => (index === 0 ? numberRegEx : regEx));
};
